import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { HrService } from 'src/app/_services/hr-management/hr.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from '../../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';

@Component({
  selector: 'app-compoff-adjustments-page',
  templateUrl: './compoff-adjustments.component.html',
  styleUrls: ['./compoff-adjustments.component.scss'],
})
export class CompOffAdjustmentsComponent implements OnInit {

    form: FormGroup;
    employeeDetailsForm;
    compOffAdjustmentsForm;
    rowData: any;
    rowSelection:any;
    selectedCheckboxData: any[] = [];
    tenantId: string;
    public columnDefs: ColDef[];
    modeAction: number = 1; //1 - create // 2 - update
    defaultColDef: any;
    gridLength = 0;
    sampleGridFrameworkComponents: any;
    // gridApi and columnApi
    private api: GridApi;
    private columnApi: ColumnApi;
    userDropdownList= [];
    currentUser: any;
    getUserName: any;

    constructor(
        private storageService: LocalStorageService,
        private HrService: HrService,
        private formBuilder: FormBuilder,
        private router: Router,
        private allocationService: AllocationService,
    ) {
        this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
        };
        this.rowSelection = 'multiple';
        this.columnDefs = this.createColumnDefs();
        

        this.sampleGridFrameworkComponents = {
            actionRowRendererComponent: ActionItemsGridRowRendererComponent,
        };

        this.form = this.formBuilder.group({
        file: ['', Validators.required],
        });

        this.employeeDetailsForm = this.formBuilder.group({
            id: new FormControl(''),
            userId: new FormControl(''),
            userName: new FormControl('')
        });

        this.compOffAdjustmentsForm = this.formBuilder.group({
            id: new FormControl(''),
            employeeId: new FormControl(''),
            employeeName: new FormControl(''),
            validityDate: new FormControl(''),
            balance: new FormControl(''),
        });
    }

    ngOnInit(): void {
        this.tenantId = this.storageService.get('tenantId');
        this.currentUser = JSON.parse(this.storageService.get('currentUser'));
        this.getUserList();
    }

    // getter for easy access to form fields
    get f() {
        return this.compOffAdjustmentsForm.controls;
    }

    getCompOffSummary(){
        let userId = this.employeeDetailsForm.get('userId').value.split(' . ')[0];
        this.HrService.getCompOffAdjustment(userId).subscribe((response: any) => {
            this.rowData = response;
        })
    }

    getUserList() {
        this.userDropdownList = [];
        this.allocationService.getUserDetails().subscribe((response) => {
            this.getUserName = response;
            for (let item of response) {
                this.userDropdownList.push(`${item.id} . ${item.firstName} ${item.lastName}`);
            }
        });
    }

    updateCompOff(){
        let employeeId = parseInt(this.compOffAdjustmentsForm.get('employeeId').value.toString().split(" . ")[0]);
        let employeeName = this.compOffAdjustmentsForm.get('employeeId').value.toString().split(" . ")[1];
        let data={
            employeeId: employeeId,
            employeeName: employeeName,
            validityDate: this.compOffAdjustmentsForm.get('validityDate').value,
            balance: parseFloat(this.compOffAdjustmentsForm.get('balance').value)
        }
        this.HrService.updateCompOffAdjustment(data, this.selectedCheckboxData[0].id).subscribe((response: any) => {
            this.getCompOffSummary();
            $('#closeModal').trigger('click');
        });
    }

    // one grid initialisation, grap the APIs and auto resize the columns to fit the available space
    onGridReady(params): void {
        this.api = params.api;
        this.columnApi = params.columnApi;
        this.api.sizeColumnsToFit();
    }

    onSelectionChanged(event) {
        this.selectedCheckboxData = [];
        let select = event.api.getSelectedNodes();
        for (let item of select) {
          this.selectedCheckboxData.push(item.data);
        }
    }

    editOpenModal() {
        this.modeAction = 2;
        this.compOffAdjustmentsForm.patchValue(this.selectedCheckboxData[0]);
        this.compOffAdjustmentsForm.value.employeeId = this.selectedCheckboxData[0].employeeId + " . " + this.selectedCheckboxData[0].employeeName;
        this.compOffAdjustmentsForm.patchValue(this.compOffAdjustmentsForm.value);
    }

    isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
    }

    // create column definitions
    private createColumnDefs() {
        return [
            {
                headerName: 'Employee Code',
                field: 'localId',
                filter: true,
                editable: false,
                sortable: true,
                headerCheckboxSelection: this.isFirstColumn,
                checkboxSelection: this.isFirstColumn,
            },
            {
                headerName: 'Employee Name',
                field: 'employeeName',
                // valueGetter: function(params) {
                //     return params.data.userId + " . " + params.data.userName;
                //   },
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Leave Date',
                field: 'leaveDate',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Application Date',
                field: 'applicationDate',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'inTime',
                field: 'inTime',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'outTime',
                field: 'outTime',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Work Time In Hrs',
                field: 'workTimeInHours',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Status',
                field: 'status',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Balance',
                field: 'balance',
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Validity Date',
                field: 'validityDate',
                filter: true,
                editable: false,
                sortable: true,
            }, 
        ];
    }

    backToLeaveAdjustment(){
        this.router.navigate([this.tenantId + '/dashboard/hr/leaves/leave-adjustments']);
      }
}